//import { filter } from "rxjs/operators";
import { MatDialog } from "@angular/material";
import { Component, OnInit } from "@angular/core";
//import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

import { ChooseBranchEntryComponent } from "../../core/choose-branch-entry/choose-branch-entry.component";

@Component({
  selector: "app-choose-branch-for-user",
  templateUrl: "./choose-branch-for-user.component.html",
  styleUrls: ["./choose-branch-for-user.component.css"]
})
export class ChooseBranchForUserComponent implements OnInit {
  showButton: boolean;
  constructor(
    //private router: Router,
    private dialog: MatDialog,
    //private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // if (this.router.navigated) {
    //   this.showButton = this.route.snapshot.firstChild.firstChild.data[
    //     "showCompanyButton"
    //   ];
    // }
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe(() => {
    //     this.showButton = this.route.snapshot.firstChild.firstChild.data[
    //       "showCompanyButton"
    //     ];
    //   });
  }
  chooseBranch() {
    this.dialog.open(ChooseBranchEntryComponent);
  }
}
